var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ic_chevron_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.9862 15.9961C11.7197 15.9966 11.4613 15.9036 11.2561 15.7334L4.41094 10.022C3.92578 9.61829 3.85938 8.89721 4.26263 8.41145C4.66588 7.92569 5.38608 7.85921 5.87124 8.26296L11.9862 13.3803L18.1012 8.44572C18.3369 8.25408 18.6392 8.16441 18.9411 8.19657C19.243 8.22873 19.5197 8.38006 19.7099 8.61706C19.9211 8.85449 20.0239 9.16932 19.9936 9.48582C19.9633 9.80232 19.8026 10.0918 19.5501 10.2848L12.705 15.8019C12.4938 15.9453 12.2408 16.0136 11.9862 15.9961Z",
    fill: "#343333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.05b8ba34c58387a6260472361a0a312c.svg";
export { ForwardRef as ReactComponent };